/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Load_Users_FailedInputs */

const en_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error loading users. ${i?.error}`)
};

const fr_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des utilisateurs. ${i?.error}`)
};

const de_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Benutzer. ${i?.error}`)
};

const it_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il caricamento degli utenti. ${i?.error}`)
};

const ru_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка загрузки пользователей. ${i?.error}`)
};

const es_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al cargar usuarios. ${i?.error}`)
};

const zh_cn2_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`加载用户时出错。${i?.error}`)
};

const ja_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザーの読み込み中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ताओं को लोड करने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_load_users_failed = /** @type {(inputs: Team_Manager_Load_Users_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao carregar usuários. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error loading users. {error}" |
*
* @param {Team_Manager_Load_Users_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_load_users_failed = /** @type {((inputs: Team_Manager_Load_Users_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Load_Users_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_load_users_failed(inputs)
	if (locale === "de") return de_team_manager_load_users_failed(inputs)
	if (locale === "it") return it_team_manager_load_users_failed(inputs)
	if (locale === "ru") return ru_team_manager_load_users_failed(inputs)
	if (locale === "es") return es_team_manager_load_users_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_load_users_failed(inputs)
	if (locale === "ja") return ja_team_manager_load_users_failed(inputs)
	if (locale === "hi") return hi_team_manager_load_users_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_load_users_failed(inputs)
	return en_team_manager_load_users_failed(inputs)
});